import mapKnownValues from "../../utils/mapKnownValues";

export type CompanyDetailsAPIResponse = {
  companyId: number;
  companyName: string;
  logoFileName?: string;
  numberOfEmployees?: number;
  payrollProvider?: string;
  tenantId: number;
  hrisAccessToken?: string;
};

export default class CompanyDetails {
  companyId = -1;
  companyName = "";
  logoFileName = "";
  numberOfEmployees = 0;
  payrollProvider = "";
  tenantId = -1;
  hrisAccessToken = "";

  _originalData = "";

  constructor(params: Partial<CompanyDetails> = {}) {
    mapKnownValues(this, { ...params });
    if (!params?._originalData) {
      this._originalData = JSON.stringify({
        ...this,
        _originalData: undefined,
      });
    }
  }

  get isCompleted() {
    return this.companyName && this.logoFileName && this.numberOfEmployees > 0 && this.payrollProvider;
  }

  static fromAPI(response: CompanyDetailsAPIResponse) {
    return new CompanyDetails({
      ...response,
      logoFileName: response.logoFileName || undefined,
      numberOfEmployees: response.numberOfEmployees || undefined,
      payrollProvider: response.payrollProvider
        ? response.payrollProvider.charAt(0).toUpperCase() + response.payrollProvider.slice(1)
        : undefined,
      hrisAccessToken: response.hrisAccessToken || undefined,
    });
  }

  get hasChanged() {
    return (
      JSON.stringify({
        ...this,
        _originalData: undefined,
      }) !== this._originalData
    );
  }

  toJSONForAPI() {
    return JSON.stringify({
      ...this,
      numberOfEmployees: this.numberOfEmployees || 0,
      _originalData: undefined,
    });
  }
}
